export const PRODUCT_SPECIFICATION_TAB = {
    SPECIFICATIONS: "specifications",
    BEVERAGES: "beverages",
} as const;

export type ProductSpecificationTabId =
    (typeof PRODUCT_SPECIFICATION_TAB)[keyof typeof PRODUCT_SPECIFICATION_TAB];

export const PRODUCT_SPEC_COLUMN_COUNT = 3;
